import mutation from './mutation.graphql.js'
import { useMutation } from 'Data/Api'
import { notifyError, useNotifications } from 'Logic/Notifications'
import { useSetFlowTo, normalizePath } from 'Simple/Flow'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'save': {
        let params = {
          account_id: value.account_id,
          doctor_id: value.doctor_id,
        }
        let mutationResponse = await executeMutation(params)

        if (
          mutationResponse.error ||
          !mutationResponse.data.apps_align_itero_set_preferences.id
        ) {
          return notify(notifyError('An error has occurred saving settings'))
        }

        change(next => {
          next.account_id = value.account_id
          next.doctor_id = value.doctor_id
          next.originalValue = params
        })

        setFlowTo(normalizePath(props.viewPath, '../No'))

        return
      }
      case 'delete': {
        let params = {
          account_id: null,
          doctor_id: null,
        }
        if (window.confirm('Are you sure that wants to delete preferences')) {
          let mutationResponse = await executeMutation(params)

          if (
            mutationResponse.error ||
            !mutationResponse.data.apps_align_itero_set_preferences.id
          ) {
            return notify(
              notifyError('An error has occurred deleting settings')
            )
          }

          change(next => {
            next.account_id = null
            next.doctor_id = null
            next.originalValue = params
          })

          setFlowTo(normalizePath(props.viewPath, '../No'))
        }
        return
      }
      default: {
      }
    }
  }
}
